const o={networkService:Symbol.for("networkService"),cookies:Symbol.for("cookies")};export{o as INVERSIFY_TYPES};
